import React, { useEffect } from 'react';
import styles from "./joining.module.scss";
import Lottie from "lottie-react";
import ContactLoader from "../styles/images/connecting.json";
import { Button } from 'antd';
import { Waiting } from '../waiting';
export const Joining = () => {



  return (<>
  
    <div className={styles.waitingConsec}>
      <div className={styles.meetingInfoPopup}>
      
        <Lottie width={80} height={ 80} className="svgLoadingConnectg forchatsvg"
          animationData={ContactLoader} />
        <p className={styles.meetingTitleText}>Joining …</p>
        <p className={styles.meetingTitleactions}>It may take a few moments.</p>
      </div>
      <div className={styles.footerbottomsec}>
        <div className={`${styles.meetingscreens} ${styles.waitingroomers}`}>
          <div className={styles.mainsection}></div>
          <div className={styles.bottomsection}>
            <div className={`${styles.sectionlist} ${styles.one}`}>
              <div className={styles.listfiles}>
                <ul className={styles.lists}>
                  <li><span className="icon_meet_footer_caption"></span></li>
                  <li><span className="icon_meet_footer_virtual_bg"></span></li>
                  <li><span className="icon_meet_footer_raise_hand"></span></li>
                </ul>
              </div>
            </div>
            <div className={`${styles.sectionlist} ${styles.two}`}>
              <div className={`${styles.listfiles} ${styles.hoverlistfiles}`}>
                <ul className={styles.lists}>
                  <li><span className="icon_Audio-on-large"></span><b>Mute</b></li>
                  <li className={styles.pophoverlists}>
                    <span className="icon_Video-on">
                    </span><span className={`icon_msg_error ${styles.errormd}`}></span><b>Start Video</b>
                  </li>
                  <li><span className="icon_Share"></span><b>Share Screen</b></li>
                </ul>
              </div>
            </div>
            <div className={`${styles.sectionlist} ${styles.three}`}>
              <div className={`${styles.listfiles} ${styles.endlistfiles}`}>
                <ul className={styles.lists}>
                  <li><span className="icon_meet_footer_chat"></span></li>
                  <li><span className="icon_meet_footer_participant"></span></li>
                  <li><span className="icon_meet_footer_settings"></span></li>
                </ul>
              </div>
              {/* <Button className={styles.endbutton}>Leave Meeting</Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
};